module.exports = __webpack_public_path__ + "img/a4.304bbd89.jpg";